import { toTitleCase } from "../../../../Utils/stringUtls";
import {
  programMngt,
} from "../../OptionalFeatures/ProgramManagementService";
import ReviewAttribute from "../../../../Components/SharedComponent/ReviewAttribute/ReviewAttribute";

const ProgramManagementServicesOverview = ({ data }) => {
  const {
    of_pms_processor,
    of_pms_company_name,
    of_pms_contact_name,
    of_pms_job_title,
    of_pms_phone_number,
    of_pms_email,  
  } = data["4_2"];
  return (
    <div className="forms-instance" style={{ color: "#111" }}>
      <div i2c-grid="grid grid" className="review-summary-gap">
        <div i2c-grid="12@md" className="review-summary-sub-heading">
          <div className="fw-700 font-bold">Program Management Services</div>
        </div>
        <ReviewAttribute
          label="Program Management Services"
          value={programMngt[of_pms_processor]?.label ?? "-"}
        />
        {of_pms_processor === 2 && (
          <>
            <ReviewAttribute
              label="Company Name"
              value={of_pms_company_name?.length ? toTitleCase(of_pms_company_name) : "-"}
            />
            <ReviewAttribute
              label="Contact Name"
              value={of_pms_contact_name?.length ? toTitleCase(of_pms_contact_name) : "-"}
            />
            <ReviewAttribute
              label="Title"
              value={of_pms_job_title?.length ? toTitleCase(of_pms_job_title) : "-"}
            />
            <ReviewAttribute
              label="Company Phone"
              value={of_pms_phone_number?.length ? toTitleCase(of_pms_phone_number) : "-"}
            />
            <ReviewAttribute
              label="Email"
              value={of_pms_email?.length ? toTitleCase(of_pms_email) : "-"}
            />
          </>
        )}        
      </div>
      <div className="divider-bottom mt-16"></div>
    </div>
  );
};
export default ProgramManagementServicesOverview;
